import React, { useEffect, useState } from 'react';
import NxtbnModal from '../../components/Modal';
import InputField from '../../components/common/InputField';
import { useQuery, gql, useMutation } from "@apollo/client";

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  refresh: () => void;
  id?: boolean;
}


const GET_CATEGORY = gql`
  query MyQuery($id: ID!) {
    category(id: $id) {
      description
      metaDescription
      metaTitle
      name
    }
  }
`;


const UPDATE_CATEGORY =  gql`
    mutation MyMutation($id: Int!, $input: NameSecriptionSEOInputType!) {
        updateCategory(id: $id, input: $input) {
            category {
                dbId
            }
        }
    }
`


function CategoryEditModal({ isOpen, onClose, refresh, id }: CategoryModalProps) {
    const [formData, setFormData] = useState<any | null>(null);

  const { loading, error, data, refetch } = useQuery(GET_CATEGORY, {
          variables: { id },
          skip: !id,
          notifyOnNetworkStatusChange: true,
      });

     const [updateCategory, { loading: mutationLoading }] = useMutation(UPDATE_CATEGORY);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    updateCategory({ variables: { id, input: formData } }).then((response: any) => {
      onClose();
      refetch();
      refresh();
    });

  };

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


    useEffect(() => {
        if (data?.category) {
            const { __typename, ...categoryData } = data.category;
            setFormData(categoryData);
        }
    }, [data]);

 

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(e); }} className="p-6">
        <h2 className="text-lg font-medium text-gray-900"> Edit Category</h2>
        <div className="mt-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Name
          </label>
          <InputField
            type="text"
            name="name"
            value={formData?.name || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
        </div>
        <div className="mt-4">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <InputField
            type="text"
            name="description"
            value={formData?.description || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
        </div>
        <div className="mt-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Meta Title
          </label>
          <InputField
            type="text"
            name="metaTitle"
            value={formData?.metaTitle || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
        </div>
        <div className="mt-4">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Meta Description
          </label>
          <InputField
            type="text"
            name="metaDescription"
            value={formData?.metaDescription || ""}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
        </div>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 text-[#0CAF60] border border-[#0CAF60] hover:bg-slate-200 text-sm font-medium rounded-md shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 px-4 py-2 focus:outline-none sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Add
          </button>
        </div>
      </form>
    </NxtbnModal>
  );
}

export default CategoryEditModal;
